"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-seventeen/section/wellnessSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type WellnessSection366FadeInDownsItem = {
    key: Key | null | undefined;
    /** Detected variants: "1.5s" | "2s" | "2.5s" | "3s" */
    dataWowDuration: string;
    /** Detected variants: "wellness-item-seventeen flex-fill rotate-1" | "wellness-item-seventeen flex-fill rotate-2" | "wellness-item-seventeen flex-fill rotate-3" | "wellness-item-seventeen flex-fill rotate-4" */
    className: string;
    /** Detected variants: "/Templates/Doccure/img/banner/count-1.png" | "/Templates/Doccure/img/banner/count-2.png" | "/Templates/Doccure/img/banner/count-3.png" | "/Templates/Doccure/img/banner/count-4.png" */
    src: string;
    /** Detected variants: "01" | "02" | "03" | "04" */
    span0Text: ReactNode;
    /** Detected variants: "Free Discovery" | "Personalized" | "Custom Wellness" | "Transform & Thrive" */
    h30Text: ReactNode;
    /** Detected variants: "Calls" | "Assessment" | "Plan" | "with Us" */
    span0Span0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/service/wellness-service-01.jpg" | "/Templates/Doccure/img/service/wellness-service-02.jpg" | "/Templates/Doccure/img/service/wellness-service-03.jpg" | "/Templates/Doccure/img/service/wellness-service-04.jpg" */
    imageWithBasePath0Src: string;
    /** Detected variants: "col-lg-3 col-md-6 col-sm-6 d-flex wow fadeInDown" */
    divClassName?: string;
    /** Detected variants: "wellness-count" */
    div0ClassName?: string;
    /** Detected variants: "count" */
    alt?: string;
    /** Detected variants: "img-fluid count-one" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "wellness-content" */
    div1ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "Connect with our wellness experts to discuss your health goals and concerns in a compassionate, judgment-free environment." */
    p0Text?: ReactNode;
    /** Detected variants: "description" */
    p0ClassName?: string;
    /** Detected variants: "service" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "img-fluid wellness-img" */
    imageWithBasePath0ClassName2?: string;
};
export type HomeSeventeenWellnessSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: WellnessSection366FadeInDownsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: WellnessSection366FadeInDownsItem) => Partial<ComponentProps<"h3">>);
    divDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: WellnessSection366FadeInDownsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Your Path to Lasting Wellness" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "A simple, supportive process designed to guide you from where you are to where you want to be" */
    sectionDiv0Div0P0PText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/blog-bg-04.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    wellnessSection366FadeInDowns: WellnessSection366FadeInDownsItem[];
    wellnessSection366FadeInDownsItemWrapper?: (item: WellnessSection366FadeInDownsItem, content: ReactNode) => ReactNode;
    wellnessSection366FadeInDownsRenderer?: (defaultNode: ReactNode) => ReactNode;
    wellnessSection366FadeInDownsImageVisible?: boolean;
    wellnessSection366FadeInDownsImageRenderer?: (item: WellnessSection366FadeInDownsItem, defaultNode: ReactNode) => ReactNode;
    wellnessSection366FadeInDownsH3Visible?: boolean;
    wellnessSection366FadeInDownsH3Renderer?: (item: WellnessSection366FadeInDownsItem, defaultNode: ReactNode) => ReactNode;
    wellnessSection366FadeInDownsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: WellnessSection366FadeInDownsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    wellnessSection366FadeInDownsH3Props?: Partial<ComponentProps<"h3">> | ((item: WellnessSection366FadeInDownsItem) => Partial<ComponentProps<"h3">>);
};

const HomeSeventeenWellnessSectionGenerated: FC<HomeSeventeenWellnessSectionGeneratedProps> = ({
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Your Path to Lasting Wellness",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0P0PText = "A simple, supportive process designed to guide you from where you are to where you want to be",
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/blog-bg-04.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div1H30H3Props,
    divDiv0ImageWithBasePath0ImageProps,
    sectionDiv0Div1ClassName,
    wellnessSection366FadeInDowns,
    wellnessSection366FadeInDownsItemWrapper,
    wellnessSection366FadeInDownsRenderer,
    wellnessSection366FadeInDownsImageVisible,
    wellnessSection366FadeInDownsImageRenderer,
    wellnessSection366FadeInDownsH3Visible,
    wellnessSection366FadeInDownsH3Renderer,
    wellnessSection366FadeInDownsImageProps,
    wellnessSection366FadeInDownsH3Props,
}) => {
    return (
        <section className="section wellness-section-seventeen">
            <div className="container">
                <div className="section-header section-header-seventeen wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title text-gradient" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                    <p className="description">{sectionDiv0Div0P0PText}</p>
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row align-items-center row-gap-4"}>
                    {renderCollectionNode(
                        wellnessSection366FadeInDowns,
                        (item: WellnessSection366FadeInDownsItem) => (
                            <div className={item.divClassName ?? "col-lg-3 col-md-6 col-sm-6 d-flex wow fadeInDown"} data-wow-duration={item.dataWowDuration} key={item.key}>
                                <div className={item.className}>
                                    <div className={item.div0ClassName ?? "wellness-count"}>
                                        <span>{item.span0Text}</span>
                                        {renderItemNode(wellnessSection366FadeInDownsImageVisible, wellnessSection366FadeInDownsImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "count"} className={item.imageWithBasePath0ClassName ?? "img-fluid count-one"} {...(typeof wellnessSection366FadeInDownsImageProps === "function" ? wellnessSection366FadeInDownsImageProps(item) : (wellnessSection366FadeInDownsImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                    <div className={item.div1ClassName ?? "wellness-content"}>
                                        {renderItemNode(wellnessSection366FadeInDownsH3Visible, wellnessSection366FadeInDownsH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof wellnessSection366FadeInDownsH3Props === "function" ? wellnessSection366FadeInDownsH3Props(item) : (wellnessSection366FadeInDownsH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>
                                                {item.h30Text}
                                                <span>{item.span0Span0Text}</span>
                                            </h3>
                                        ))}
                                        <p className={item.p0ClassName ?? "description"}>{item.p0Text ?? "Connect with our wellness experts to discuss your health goals and concerns in a compassionate, judgment-free environment."}</p>
                                    </div>
                                    {renderItemNode(wellnessSection366FadeInDownsImageVisible, wellnessSection366FadeInDownsImageRenderer, item, (
                                        <SmartImage src={item.imageWithBasePath0Src} alt={item.imageWithBasePath0Alt ?? "service"} className={item.imageWithBasePath0ClassName2 ?? "img-fluid wellness-img"} {...(typeof wellnessSection366FadeInDownsImageProps === "function" ? wellnessSection366FadeInDownsImageProps(item) : (wellnessSection366FadeInDownsImageProps ?? {}))} {...(typeof divDiv0ImageWithBasePath0ImageProps === "function" ? divDiv0ImageWithBasePath0ImageProps(item) : (divDiv0ImageWithBasePath0ImageProps ?? {}))} />
                                    ))}
                                </div>
                            </div>
                        ),
                        wellnessSection366FadeInDownsItemWrapper,
                        wellnessSection366FadeInDownsRenderer
                    )}
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid wellness-bg-1 d-none d-lg-block" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeSeventeenWellnessSectionGenerated;
